import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-admin-institution-type-add',
  templateUrl: './admin-institution-type-add.component.html'
})
export class AdminInstitutionTypeAddComponent implements OnInit {
  @Input() formdata;
  @Input() groups;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(
    private fb: FormBuilder, 
    private router: Router) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: [null, ''],
      prefix: ['', ''],
      name: ['', ''],
      branchId: ['', ''],
      description: ['', ''],
      institutionGroupId: ['', '']
    });
  
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.form.reset();
      }
    })
  }

  saveInstitutionType() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  cancel() {
    this.doCancel.emit();
  }

  setGroup(evt) {
    this.form.patchValue({institutionGroupId: evt.value});
  }

}
